import { useLanguage } from '../i18n/LanguageContext';
import apps from '../data/apps';
import { localized } from '../utils/localized';
import './AppList.css';

function AppList({ selectedAppId, onSelectApp }) {
  const { t, locale } = useLanguage();

  return (
    <section className="app-list" aria-label={t('apps.title')}>
      <h2 className="section-title">{t('apps.title')}</h2>
      <p className="app-list-hint">{t('apps.hint')}</p>
      <div className="app-grid" role="listbox" aria-label={t('apps.title')}>
        {apps.map((app) => {
          const name = localized(app.name, locale);
          const isSelected = app.id === selectedAppId;

          return (
            <button
              key={app.id}
              type="button"
              role="option"
              aria-selected={isSelected}
              className={`app-card${isSelected ? ' app-card--selected' : ''}`}
              onClick={() => onSelectApp(app.id)}
            >
              {app.icon ? (
                <img
                  className="app-card-icon"
                  src={app.icon}
                  alt=""
                  width={48}
                  height={48}
                />
              ) : (
                <div
                  className="app-card-icon app-card-icon--placeholder"
                  aria-hidden="true"
                />
              )}
              <div className="app-card-body">
                <h3>{name}</h3>
                <p>{localized(app.tagline, locale)}</p>
                {app.appStoreUrl && (
                  <a
                    href={app.appStoreUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="app-card-link"
                    onClick={(event) => event.stopPropagation()}
                  >
                    {t('apps.appStore')}
                  </a>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}

export default AppList;
